module.exports = __webpack_public_path__ + "static/media/check-white.600cf76f.svg";